import { securedAxiosInstance } from "../axios";
import { toCamelCase, toSnakeCase } from "@estaly/ui";

class OrganizationService {
  async getOrganization(organizationId, includes = []) {
    const response = await securedAxiosInstance.get(`/organizations/${organizationId}`, {
      params: { includes },
    });
    return toCamelCase(response.data);
  }

  updateOrganization(organizationId, data) {
    return securedAxiosInstance.put(`/organizations/${organizationId}`, { organization: toSnakeCase(data) });
  }
}

export default new OrganizationService();
